import { ReactNode } from "react";

import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryUsername from "components/Run/elements/HistoryEntryUsername";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";

import { RunHistoryEntryType } from "../../types";

type StoppedEntryProps = {
  timestamp: number;
  username: string | null;
  children: ReactNode;
};

const StoppedEntry = ({ timestamp, username, children }: StoppedEntryProps) => {
  const label = (
    <HistoryEntryLabel>
      <strong>Stopped</strong> <HistoryEntryUsername username={username} />
    </HistoryEntryLabel>
  );

  return (
    <HistoryEntryWrapper
      label={label}
      state={RunHistoryEntryType.Stopped}
      timestamp={timestamp}
      terminal
    >
      {children}
    </HistoryEntryWrapper>
  );
};

export default StoppedEntry;
